import { GalleryImageProps } from "@/components/Gallery/components/GalleryImage/GalleryImageProps.ts";
import { useState } from "react";

export const GalleryImage = (props: GalleryImageProps) => {
  const [loaded, setLoaded] = useState(false);
  return (
    <>
      {!loaded && <div className="c-gallery__image__skeleton" />}
      <img
        onLoad={() => setLoaded(true)}
        loading={props?.loading || "eager"}
        className={`c-gallery__image${props.disabled ? "--unavailable" : ""}`}
        src={props.url}
        alt="SWEN"
      />
    </>
  );
};
